// Mirrors the redirect branches in layouts/authenticationTest.vue's login() handler,
// so a returning logged-in user lands in the same place a fresh login would send them.
export function getDashboardPath(userRole, mainRole) {
  if (mainRole == "official") return "/officers/sarpadashboard";
  if (userRole == "admin") return "/Sarpa/dashboard";
  if (userRole == "RRT") return "/officers/sarpadashboard";
  if (mainRole == "MedicalOfficer") return "/medicalOfficers/stockVenom";
  if (mainRole == "District Emergency Officer") return "/DistrictEmergencyOfficer/districtDashboard";
  return "/";
}
